import {Component, OnInit, Optional, inject} from '@angular/core';
import {NZ_MODAL_DATA, NzModalRef} from "ng-zorro-antd/modal";
import {ModalService} from "../../../lean-shared/components/nz-modal-service/modal.service";

@Component({
  selector: 'ng-mf-kamona-progress-modal',
  templateUrl: './kamona-progress-modal.component.html',
  styleUrls: ['./kamona-progress-modal.component.scss']
})
export class KamonaProgressModalComponent implements OnInit {

	description = 'Loading ...';
	extraDescription = 'please hold on...';
	useExtraDescription = true;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};
	constructor(
		@Optional() private modal: NzModalRef,
		public modalService: ModalService
	) {}

	ngOnInit(): void {
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.description = this.modal?.componentInstance?.data?.description;
		this.useExtraDescription = this.modal.componentInstance.data?.useExtraDescription;
	}

}
